import styled from 'styled-components';

export default function DisplayName({ displayName, displayNameFontSize = 2.5 }) {
	if (!displayName || !displayName.length) {
		return false;
	}

	return (
		<StyledH1
			id="slp-display-name"
			displayNameFontSize={displayNameFontSize}
			className="container text-center mb-3"
		>
			{displayName}
		</StyledH1>
	);
}

const StyledH1 = styled.h1`
	font-size: ${(props) => props.displayNameFontSize}rem;
`;
